<template>
  <FilterForm
    :formData="filterData"
    :filters="filters"
    @closeUp="closeUp"
    @unflod="unflod"
    @submit="handleSubmit"
    @reset="handleReset"
    @changeDept="changeDept"
  />
  <div class="distribution-btn">
    <el-button v-if="buttons.includes('分配按钮')"
      size="small"
      type="primary"
      @click="handleDistribution"
    >分配给</el-button>
    <el-button v-if="buttons.includes('移至轮转客户按钮')"
               type="primary"
               size="small"
               @click="handleCirculation"
    >移至入轮转客户</el-button>
    <el-button
      type="primary"
      size="small"
      @click="handleImport"
    >移入重要客户</el-button>
    <el-button
      type="primary"
      size="small"
      @click="handlePassage"
    >移入在途客户</el-button>
    <el-button
      type="primary"
      size="small"
      @click="handlePublicPool"
    >移入公海</el-button>
    <el-button
        type="primary"
        size="small"
        @click="handleRubbish"
    >放入垃圾库</el-button>
  </div>

  <AssginCustomerTable
    ref="tableRef"
    :tableColumn="tableColumn"
    :tableData="tableData"
    :selection="true"
    @selection="handleSelectionChange"
    @followRecords="followRecords"
    @nameDrawer="handleNameDrawer"
  />
  <AssginCustomerPagination
    :total="total"
    @currentChange="currentChange"
    @sizeChange="sizeChange"
  />
  <DialogFollowRecords
    :isShowDialog="isShowFollow"
    :width="500"
    @close="handleFollowClose"
    :list="followList"
  />
  <DistributionDialog
    title="分配给"
    :isShowDialog="isShowDialog"
    :forms="forms"
    :formData="formData"
    :width="500"
    @submit="handleDistributionSubmit"
    @close="handleClose"
  />
  <CustomerDetail
    width="1200px"
    :isShowDialog="isShowDrawer"
    @close="handleDrawerClose"
    direction="rtl"
    :userId="drawerId"
    @prev="handlePrevCustomer"
    @next="handleNextCustomer"
    :isRightOperation="true"
  />
</template>

<script>
import FilterForm from "@/components/filter";
import AssginCustomerTable from "@/components/table";
import AssginCustomerPagination from "@/components/pagination";
import { computed, onMounted, reactive, ref, watch } from "vue";
import {  allfilterArr, tableColumn } from "./index.js";
import { useStore } from "vuex";
import { getUserByDept, getDictionaries } from "@/api/method/common";
import {
  distribute,
  movetoImportant, movetoPassage,
  movetoPublicPool,
  checkNonFollow,
  movetoCirculation
} from "@/api/method/customer";
import { getDistributeUsers } from "@/api/method/system";
import moment from "moment";
import { reset } from "@/until";
import { ElButton, ElMessage } from "element-plus";
import DistributionDialog from "@/components/dialog-form";
import DialogFollowRecords from "@/components/dialog-followRecords";
import { getChannelList } from "@/api/method/channel";
import { movetoRubbish } from "@/api/method/customer";
import CustomerDetail from "@/components/drawer-form/index.vue";

export default {
  name: "AssginCustomer",
  props: ["options", "departments"],
  components: {
    FilterForm,
    AssginCustomerTable,
    AssginCustomerPagination,
    [ElButton.name]: ElButton,
    DialogFollowRecords,
    DistributionDialog,
    CustomerDetail,
  },

  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      deptId: null,
      userId: null,
      search: null,
      starStatus: null,
      status: null,
      followDate: null,
      source: null,
      remark: null,
      customerAttr: [],
    });

    const filters = ref(allfilterArr);
    const buttons = ref(localStorage.getItem("buttons").split(","));
    const unflod = () => {
      filters.value = allfilterArr;
    };

    onMounted(() => {
      getList();
      dictionaries();
      getDepartList();
      loadChannelList();
    });
    const pagination = reactive({
      page: 1,
      size: 10,
    });
    const tableData = computed(
      () => (state.assginCustomerList && state.assginCustomerList.records) || []
    );
    const total = computed(
      () => state.assginCustomerList && state.assginCustomerList.total
    );
    const getList = () => {
      customerIds.value = [];
      const { followDate,createTime, customerAttr, ...params } = filterData;
      const followStartDate =
        followDate && moment(followDate[0]).format("YYYY-MM-DD");
      const followEndDate =
        followDate && moment(followDate[1]).format("YYYY-MM-DD");
      const createStartDate = createTime && createTime[0];
      const createEndDate = createTime && createTime[1];

      const room = customerAttr.find((item) => item == 1) ? 1 : 0;
      const accumulation = customerAttr.find((item) => item == 2) ? 1 : 0;
      const social = customerAttr.find((item) => item == 3) ? 1 : 0;
      const car = customerAttr.find((item) => item == 4) ? 1 : 0;
      const enterprise = customerAttr.find((item) => item == 5) ? 1 : 0;
      const policy = customerAttr.find((item) => item == 6) ? 1 : 0;
      const business = customerAttr.find((item) => item == 7) ? 1 : 0;
      const issued = customerAttr.find((item) => item == 8) ? 1 : 0;
      dispatch("assginCustomerList", {
        ...pagination,
        followStartDate,
        followEndDate,
        createStartDate,
        createEndDate,
        room,
        accumulation,
        social,
        car,
        enterprise,
        policy,
        business,
        issued,
        ...params,
      });
    };

    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    const filterOption = ref(null);
    watch(
      () => filters.value,
      () => {
        filters.value[0][0].option = deptList.value;
        filters.value[0][1].option = userList.value;
      }
    );

    const dictionaries = async () => {
      const res = await getDictionaries();
      filterOption.value = res.data;
        filters.value[1][2].option = filterOption.value.statusList.map(
            (item) => ({
              label: item.label,
              val: item.vlaue,
            })
        );
        filters.value[1][0].option = filterOption.value.starList.map(
            (item) => ({
              label: item.label,
              val: item.vlaue,
            })
        );
    };

    const deptList = ref([]);
    const getDepartList = async () => {
      await dispatch("departmentList");
      deptList.value = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
      filters.value[0][0].option = deptList.value;
    };
    const userList = ref(null);
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filterData.userId = null;
      userList.value = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
      filters.value[0][1].option = userList.value;
    };

    const channelList = ref([]);
    const loadChannelList = async () => {
      const res = await getChannelList();

      channelList.value = res.data.map((item) => ({
        label: item.name,
        val: item.id,
      }));

      filters.value[3][0].option = channelList.value;
    };

    const closeUp = () => {
      filters.value = allfilterArr;
    };

    const handleSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };
    const customerIds = ref([]);
    const handleSelectionChange = (arr) => {
      customerIds.value = arr.map((item) => item.id);
    };
    const isShowFollow = ref(false);
    const followList = ref([]);

    const followRecords = (row) => {
      isShowFollow.value = true;
      followList.value = row.followRecords;
    };
    const handleFollowClose = () => (isShowFollow.value = false);

    const handleRubbish = async () => {

      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }

      const res = await movetoRubbish(customerIds.value);
      if (res.code == 200) {
         getList()
      }
    };

    const handleImport = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }
      const res = await movetoImportant(customerIds.value);

      if (res.code == 200) {
        ElMessage.success("移入重要客户成功！");
        getList();
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handleCirculation = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }
      const res = await movetoCirculation(customerIds.value);

      if (res.code == 200) {
        ElMessage.success("移入轮转客户成功！");
        getList();
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handlePassage = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }
      const res = await movetoPassage(customerIds.value);

      if (res.code == 200) {
        ElMessage.success("移入在途客户成功！");
        getList();
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handlePublicPool = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }
      const res = await movetoPublicPool(customerIds.value);

      if (res.code == 200) {
        ElMessage.success("移入公海成功！");
        getList();
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handleDistribution = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }
      isShowDialog.value = true;
      const res = await getDistributeUsers();

      forms[0][0].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };
    /**分配给弹窗 */
    const isShowDialog = ref(false);
    const handleClose = () => (isShowDialog.value = false);
    const forms = reactive([
      [
        {
          label: "分配给",
          type: "select",
          multiple: true,
          attr: "userId",
          placeholder: "请选择销售人员",
          column: 24,
          filterable:true,
          labelWidth: "120px",
          option: [],
        },
      ],
    ]);
    const formData = reactive({
      userId: null,
    });
    const tableRef = ref(null)
    const handleDistributionSubmit = async () => {
      const res = await distribute({
        userId: formData.userId,
        customerIds: customerIds.value,
      });

      if (res.code == 200) {
        ElMessage.success("分配成功！");
        getList();
        handleClose();
      } else {
        ElMessage.error(res.msg);
      }
      tableRef.value.clearSection();
    };

    const isShowDrawer = ref(false);
    const handleDrawerClose = () => (isShowDrawer.value = false);
    const drawerId = ref(null);
    const handleNameDrawer = async (row) => {
      const { code, msg } = await checkNonFollow(row.id);
      if (code === 706){
        ElMessage.error(msg);
        return
      }
      isShowDrawer.value = true;
      drawerId.value = row.id;
    };
    const index = ref(0);
    const nextIndex = () => {
      index.value = 0;
      drawerId.value = tableData.value[index.value].id;
    };
    /**客户详情-上一个和下一个 */
    const handleNextCustomer = async () => {
      index.value =
        tableData.value.findIndex((item) => item.id == drawerId.value) + 1;
      if (index.value == tableData.value.length) {
        if (pagination.page < state.assginCustomerList.pages) {
          pagination.page += 1;
          await getList();
          await nextIndex();
        } else {
          ElMessage.error("已经是最后一个客户了！");
          return;
        }
      } else {
        drawerId.value = tableData.value[index.value].id;
      }
    };
    const prevIndex = () => {
      index.value = 9;
      drawerId.value = tableData.value[index.value].id;
    };
    const handlePrevCustomer = async () => {
      index.value =
        tableData.value.findIndex((item) => item.id == drawerId.value) - 1;
      if (index.value < 0) {
        if (pagination.page > 1) {
          pagination.page -= 1;
          await getList();
          await prevIndex();
        } else {
          ElMessage.error("已经是第一个客户了！");
          return;
        }
      } else {
        drawerId.value = tableData.value[index.value].id;
      }
    };

    return {
      filters,
      filterData,
      unflod,
      closeUp,
      handleSubmit,
      handleReset,
      changeDept,
      tableData,
      tableColumn,
      total,
      handleSelectionChange,
      followRecords,
      isShowFollow,
      followList,
      handleFollowClose,
      tableRef,
      handleDistributionSubmit,
      handleDrawerClose,
      handleNameDrawer,
      handleImport,
      handlePassage,
      handleCirculation,
      handlePublicPool,
      handleDistribution,
      handleClose,
      handleRubbish,
      drawerId,
      isShowDrawer,
      isShowDialog,
      buttons,
      forms,
      formData,
      currentChange,
      sizeChange,
      handleNextCustomer,
      handlePrevCustomer,
    };
  },
};
</script>

<style>
</style>
